import React, { useState, useEffect } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useParams, useHistory, useLocation } from "react-router-dom";
import ship from '../../../Assets/Announcement/Assets-Desktop/ship.svg';
import '../../../css/Vessel/VesselDetail.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { VESSEL_DETAILS_ENDPOINT, CONTAINER_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { successContainerTrip } from '../../../Redux/_actions/containerTripData.action';

const VesselDetail = props => {
    const dispatch = useDispatch();
    const paramObj = useParams();
    let history = useHistory();
    const search = useLocation().search;
    // for user type redux state
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const containerTripDataR = useSelector(state => state.containerTripData.data);
    const [VesselDetails, setVesselDetails] = useState([]);
    const [loading, setLoading] = useState(0);
    const [discharge, setDischarge] = useState(0);

    // vessel data for date and time
    const [eta, setEta] = useState('');
    const [ata, setAta] = useState('');
    const [etd, setEtd] = useState('');
    const [atd, setAtd] = useState('');

    const [stackOpenDate, setStackOpenDate] = useState('');
    const [dryStackClose, setDryStackClose] = useState('');
    const [reeferStackClose, setReeferStackClose] = useState('');
    const [hazStackClose, setHazStackClose] = useState('');

    const getTime = (timeStamp) => {
        if (timeStamp) {
            if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
                let timeStampNum = parseInt(timeStamp);
                return new Date(timeStampNum)?.toGMTString()?.split(' ')[4]?.substring(0, 5)
            }
        }
        return timeStamp
    }
    const getDate = (timeStamp) => {
        if (timeStamp) {
            if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
                let timeStampNum = parseInt(timeStamp)
                let date = new Date(timeStampNum)?.toGMTString();
                let day = date?.split(' ')[1];
                let month = date?.split(' ')[2];
                let year = date?.split(' ')[3];
                return `${day}-${month}-${year}`;
            }
        }
        return timeStamp
    }
    const validatePercent = (val) => {
        if (val) {
            if (!isNaN(val)) {
                if (parseInt(val) <= 100) {
                    return val
                }
            }
        }
        return '0';
    }

    useEffect(() => {

        const { containerNumber, tripType, vesselInfo, position } = paramObj;
        const { facilityCode, vesselRefNbr } = paramObj;
        console.log("param", paramObj);
        const terminalName = new URLSearchParams(search).get('terminal');
        const vesselName = new URLSearchParams(search).get('vessel');
        console.log("history vd", history);
        // via container details
        if (containerNumber) {
            if (!containerTripDataR) {
                ApiCall(
                    'GET',
                    trackingBaseURL + CONTAINER_DETAILS_ENDPOINT + `?containerNumber=${containerNumber}`,
                    {},
                    {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                ).then((apiData) => {

                    if (apiData.flag != -1) {
                        if (apiData.flag == 500) {
                            console.log('500');
                        }
                        else {
                            console.log('I am 200!');
                            apiData?.map((name, index) => {
                                if (name.container.tripType == "Transship") {
                                    name.container.tripType = "Transshipment"
                                }
                                return name;
                            });
                            apiData?.find((name) => {
                                if (name?.container?.tripType === tripType && name?.position === position) {
                                    dispatch(successContainerTrip(name));
                                }
                                if (name?.container?.tripType === tripType && vesselInfo === "Inbound" && name?.position === position) {
                                    setVesselDetails(name?.vesselInfo);
                                    setEta(getDate(name?.vesselInfo?.eta) + ' ' + getTime(name?.vesselInfo?.eta));
                                    setAta(getDate(name?.vesselInfo?.ata) + ' ' + getTime(name?.vesselInfo?.ata));
                                    setEtd(getDate(name?.vesselInfo?.etd) + ' ' + getTime(name?.vesselInfo?.etd));
                                    setAtd(getDate(name?.vesselInfo?.atd) + ' ' + getTime(name?.vesselInfo?.atd));
                                    setStackOpenDate(getDate(name?.vesselInfo?.stackOpenDate) + ' ' + getTime(name?.vesselInfo?.stackOpenDate));
                                    setDryStackClose(getDate(name?.vesselInfo?.dryStackClose) + ' ' + getTime(name?.vesselInfo?.dryStackClose));
                                    setReeferStackClose(getDate(name?.vesselInfo?.reeferStackClose) + ' ' + getTime(name?.vesselInfo?.reeferStackClose));
                                    setHazStackClose(getDate(name?.vesselInfo?.hazStackClose) + ' ' + getTime(name?.vesselInfo?.hazStackClose));
                                    setLoading(validatePercent(name?.vesselInfo?.loadingPercent));
                                    setDischarge(validatePercent(name?.vesselInfo?.dischargePercent));
                                }
                                if (name.container.tripType === tripType && vesselInfo === "Outbound" && name.position === position) {
                                    setVesselDetails(name?.outVesselInfo);
                                    setEta(getDate(name?.outVesselInfo?.eta) + ' ' + getTime(name?.outVesselInfo?.eta));
                                    setAta(getDate(name?.outVesselInfo?.ata) + ' ' + getTime(name?.outVesselInfo?.ata));
                                    setEtd(getDate(name?.outVesselInfo?.etd) + ' ' + getTime(name?.outVesselInfo?.etd));
                                    setAtd(getDate(name?.outVesselInfo?.atd) + ' ' + getTime(name?.outVesselInfo?.atd));
                                    setStackOpenDate(getDate(name?.outVesselInfo?.stackOpenDate) + ' ' + getTime(name?.outVesselInfo?.stackOpenDate));
                                    setDryStackClose(getDate(name?.outVesselInfo?.dryStackClose) + ' ' + getTime(name?.outVesselInfo?.dryStackClose));
                                    setReeferStackClose(getDate(name?.outVesselInfo?.reeferStackClose) + ' ' + getTime(name?.outVesselInfo?.reeferStackClose));
                                    setHazStackClose(getDate(name?.outVesselInfo?.hazStackClose) + ' ' + getTime(name?.outVesselInfo?.hazStackClose));
                                    setLoading(validatePercent(name?.outVesselInfo?.loadingPercent));
                                    setDischarge(validatePercent(name?.outVesselInfo?.dischargePercent));
                                }
                            });
                        }
                    }
                });
            } else {
                if (containerTripDataR.container.tripType === tripType && vesselInfo === "Inbound" && containerTripDataR.position === position) {
                    setVesselDetails(containerTripDataR?.vesselInfo);
                    setEta(getDate(containerTripDataR?.vesselInfo?.eta) + ' ' + getTime(containerTripDataR?.vesselInfo?.eta));
                    setAta(getDate(containerTripDataR?.vesselInfo?.ata) + ' ' + getTime(containerTripDataR?.vesselInfo?.ata));
                    setEtd(getDate(containerTripDataR?.vesselInfo?.etd) + ' ' + getTime(containerTripDataR?.vesselInfo?.etd));
                    setAtd(getDate(containerTripDataR?.vesselInfo?.atd) + ' ' + getTime(containerTripDataR?.vesselInfo?.atd));
                    setStackOpenDate(getDate(containerTripDataR?.vesselInfo?.stackOpenDate) + ' ' + getTime(containerTripDataR?.vesselInfo?.stackOpenDate));
                    setDryStackClose(getDate(containerTripDataR?.vesselInfo?.dryStackClose) + ' ' + getTime(containerTripDataR?.vesselInfo?.dryStackClose));
                    setReeferStackClose(getDate(containerTripDataR?.vesselInfo?.reeferStackClose) + ' ' + getTime(containerTripDataR?.vesselInfo?.reeferStackClose));
                    setHazStackClose(getDate(containerTripDataR?.vesselInfo?.hazStackClose) + ' ' + getTime(containerTripDataR?.vesselInfo?.hazStackClose));
                    setLoading(validatePercent(containerTripDataR?.vesselInfo?.loadingPercent));
                    setDischarge(validatePercent(containerTripDataR?.vesselInfo?.dischargePercent));
                }
                if (containerTripDataR?.container?.tripType === tripType && vesselInfo === "Outbound" && containerTripDataR?.position === position) {
                    setVesselDetails(containerTripDataR.outVesselInfo);
                    setEta(getDate(containerTripDataR?.outVesselInfo?.eta) + ' ' + getTime(containerTripDataR?.outVesselInfo?.eta));
                    setAta(getDate(containerTripDataR?.outVesselInfo?.ata) + ' ' + getTime(containerTripDataR?.outVesselInfo?.ata));
                    setEtd(getDate(containerTripDataR?.outVesselInfo?.etd) + ' ' + getTime(containerTripDataR?.outVesselInfo?.etd));
                    setAtd(getDate(containerTripDataR?.outVesselInfo?.atd) + ' ' + getTime(containerTripDataR?.outVesselInfo?.atd));
                    setStackOpenDate(getDate(containerTripDataR?.outVesselInfo?.stackOpenDate) + ' ' + getTime(containerTripDataR?.outVesselInfo?.stackOpenDate));
                    setDryStackClose(getDate(containerTripDataR?.outVesselInfo?.dryStackClose) + ' ' + getTime(containerTripDataR?.outVesselInfo?.dryStackClose));
                    setReeferStackClose(getDate(containerTripDataR?.outVesselInfo?.reeferStackClose) + ' ' + getTime(containerTripDataR?.outVesselInfo?.reeferStackClose));
                    setHazStackClose(getDate(containerTripDataR?.outVesselInfo?.hazStackClose) + ' ' + getTime(containerTripDataR?.outVesselInfo?.hazStackClose));
                    setLoading(validatePercent(containerTripDataR?.outVesselInfo?.loadingPercent));
                    setDischarge(validatePercent(containerTripDataR?.outVesselInfo?.dischargePercent));
                }
            }
        }
        if (vesselRefNbr) {

            ApiCall(
                'GET',
                trackingBaseURL + VESSEL_DETAILS_ENDPOINT + `?facilityCode=${facilityCode}&vesselRefNbr=${vesselRefNbr}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            ).then((apiData) => {
                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        setVesselDetails(apiData
                            , () =>
                                setLoading(
                                    !isNaN(apiData.statusPercent) &&
                                        apiData?.statusPercent?.length > 0
                                        ? apiData.statusPercent
                                        : 0,
                                ),
                        )
                        setEta(getDate(apiData?.eta) + ' ' + getTime(apiData?.eta));
                        setAta(getDate(apiData?.ata) + ' ' + getTime(apiData?.ata));
                        setEtd(getDate(apiData?.etd) + ' ' + getTime(apiData?.etd));
                        setAtd(getDate(apiData?.atd) + ' ' + getTime(apiData?.atd));
                        setStackOpenDate(getDate(apiData?.stackOpenDate) + ' ' + getTime(apiData?.stackOpenDate));
                        setDryStackClose(getDate(apiData?.dryStackClose) + ' ' + getTime(apiData?.dryStackClose));
                        setReeferStackClose(getDate(apiData?.reeferStackClose) + ' ' + getTime(apiData?.reeferStackClose));
                        setHazStackClose(getDate(apiData?.hazStackClose) + ' ' + getTime(apiData?.hazStackClose));
                        setLoading(validatePercent(apiData?.loadingPercent));
                        setDischarge(validatePercent(apiData?.dischargePercent));
                    }
                } else {
                    console.log('Something went wrong!');
                }
            });
        }


        return () => {

            if (history.action === 'POP' && history.location.pathname === '/vessel') {
                history.replace({
                    pathname: '/vessel',
                    state: {
                        facilityCode: facilityCode, vesselRefNbr: vesselRefNbr,
                        terminal: terminalName,
                        vesselName: vesselName,
                    }
                }
                );
            }
        };
    }, [history]);

    return (
        <div >
            <MetaDecorator title={TitleDescription.vesselDetailPageTitle} description={TitleDescription.vesselDetailPageDescription} />
            <Header tilesFetched={() => { }} />

            <div class="vsdfull">
                <div className='vweathernavbar'>
                    <small id="vesselstatus">Vessel Status</small>
                </div><hr className='navbarhr' />
                <div className='settingsectionPart'>
                    <div className='head'>
                        <img alt="" src={ship} width="35" height="30" class=" pt-1 mb-2" loading="lazy" />
                        <p className='vesselText'>Vessel Name</p>
                        <p className='vesselName'>{VesselDetails?.vesselName}</p>
                    </div>
                    {manageProfileDataR?.tileUserType == "Preview" ?
                        <div>
                            <div className='outerRectangle'>
                                <div className="innerRectangles">
                                    <p className='key'>Visit ID</p>
                                    <p className='value'>{VesselDetails?.visitId}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Inbound Voyage No.</p>
                                    <p className='value'>{VesselDetails?.inVoyageNbr}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Outbound Voyage No.</p>
                                    <p className='value'>{VesselDetails?.outVoyageNbr}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt01">StackOpen On (Being Received)</p>
                                    <p className='value'>{stackOpenDate}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt02">StackClose On (Cutoff) </p>
                                    <p></p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Dry </p>
                                    <p className='value'>{dryStackClose}</p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Hazard </p>
                                    <p className='value'>{hazStackClose}</p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Reefer </p>
                                    <p className='value'>{reeferStackClose}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Status</p>
                                    <p className='value'>{VesselDetails?.status}
                                    </p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Line Operator</p>
                                    <p className='value'>{VesselDetails?.lineOperator}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Service</p>
                                    <p className='value'>{VesselDetails?.service}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ETA (Anchorage)</p>
                                    <p className='value'>{eta}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ATA (Berth)</p>
                                    {/* pending */}
                                    <p className='value'>{ata}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ETD (Departure)</p>
                                    <p className='value'>{etd}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ATD (Departure)</p>
                                    <p className='value'>{atd}</p>
                                </div>
                            </div>
                        </div>
                        :
                        null
                    }
                    {manageProfileDataR?.tileUserType == "Premium" ?
                        <div>
                            <div className='outerRectangle'>
                                <div className="innerRectangles">
                                    <p className='key'>Visit ID</p>
                                    <p className='value'>{VesselDetails?.visitId}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Inbound Voyage No.</p>
                                    <p className='value'>{VesselDetails?.inVoyageNbr}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Outbound Voyage No.</p>
                                    <p className='value'>{VesselDetails?.outVoyageNbr}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt01">StackOpen On (Being Received)</p>
                                    <p className='value'>{stackOpenDate}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt02">StackClose On (Cutoff) </p>
                                    <p></p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Dry </p>
                                    <p className='value'>{dryStackClose}</p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Hazard </p>
                                    <p className='value'>{hazStackClose}</p>
                                </div>
                                <div className="innerRectanglesData">
                                    <p className='keyData' id="vessalwidt02">Reefer </p>
                                    <p className='value'>{reeferStackClose}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Status</p>
                                </div>
                                <div id="VesselLodingDiv" className="innerRectanglesData">
                                    <div className='keyData' id="vessalwidt02">Loading </div>
                                    <div className='value' id="loadingDischarge">
                                        <div className="loadingbarDischarge">
                                            <ProgressBar now={loading} />
                                            <div className='progressTextDischarge'>{loading}% Complete</div>
                                        </div>
                                    </div>
                                </div>
                                <div id="VesselDischargingDiv" className="innerRectanglesData">
                                    <div className='keyData' id="vessalwidt02">Discharging </div>
                                    <div className='value' id="loadingDischarge">
                                        {/* Discharging */}
                                        <div className="loadingbarDischarge">
                                            <ProgressBar now={discharge} />
                                            <div className='progressTextDischarge'>{discharge}% Complete</div>
                                        </div>
                                    </div>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Line Operator</p>
                                    <p className='value'>{VesselDetails?.lineOperator}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Service</p>
                                    <p className='value'>{VesselDetails?.service}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ETA (Anchorage)</p>
                                    <p className='value'>{eta}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ATA (Berth)</p>
                                    <p className='value'>{ata}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ETD (Departure)</p>
                                    <p className='value'>{etd}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key' id="vessalwidt03">ATD (Departure)</p>
                                    <p className='value'>{atd}</p>
                                </div>
                                <hr className='borderbottom' />
                                <div className="innerRectangles">
                                    <p className='key'>Location</p>
                                    <a className='view' style={{ textDecoration: 'none', color: '#D53127' }}>View</a>
                                </div>
                            </div>
                        </div>
                        :
                        null}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default VesselDetail;